import type { UpdatePlanResponse } from '@weft/api-definition';
import { UpdatePlanResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { UpdatePlanRequest } from './use-update-plan-types/update-plan-request';

export function useUpdatePlan(options?: UseMutationOptions<UpdatePlanResponse, unknown, UpdatePlanRequest>) {
  return useMutation(async (updatePlanRequest: UpdatePlanRequest) => {
    const api = getPrivateApi();
    const updatePlanResponse = await api.updatePlan(updatePlanRequest);

    return UpdatePlanResponseSchema.parse(updatePlanResponse);
  }, options);
}